import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import React from 'react';
import {
    Controlled_AutocompleteMultiSelectReferenceTextField,
} from './Controlled_AutocompleteMultiSelectReferenceTextField';
import { useToolActions } from '../../../../resource/resources/artifacts/tool/toolResource';

export const Controlled_ToolTextField= ({ objectIds, projectVersionId, onChange, readOnly, noLabel, propertyValidationInformation }: {
    objectIds: string[] | undefined;
    projectVersionId: string | undefined | null;
    onChange?: (id: string[] | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation?: PropertyValidationInformation;
}) => {

    const toolActions = useToolActions()
    const toolsQuery = toolActions.useGetAllResources(projectVersionId);

    return (
        <Controlled_AutocompleteMultiSelectReferenceTextField
            idValues={objectIds}
            readOnly={readOnly}
            onChange={onChange}
            // propertyValidation={propertyValidation}
            // propertyDetails={noLabel ? undefined : propertyDetails}
            propertyValidation={null}
            propertyDetails={undefined}
            query={toolsQuery}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
        />
    );
};